// VNEC v9 — lib/session.js
// Quản lý phiên làm việc theo dự án (per-project scope cho data_entry)
import { supabase, rpc } from './supabase.js';

let _cache = {
  myProjects: null,
  currentProject: null,
  lastFetch: 0
};

const CACHE_TTL = 30000; // 30s

export async function getMyProjects(forceRefresh = false) {
  const now = Date.now();
  if (!forceRefresh && _cache.myProjects && (now - _cache.lastFetch) < CACHE_TTL) {
    return _cache.myProjects;
  }
  const data = await rpc('get_my_projects');
  _cache.myProjects = data || [];
  _cache.lastFetch = now;
  return _cache.myProjects;
}

export async function getCurrentProject(forceRefresh = false) {
  if (!forceRefresh && _cache.currentProject !== null) return _cache.currentProject;
  const data = await rpc('get_current_project');
  _cache.currentProject = data || '';
  return _cache.currentProject;
}

export async function setCurrentProject(maDa) {
  await rpc('set_current_project', { p_ma_da: maDa });
  _cache.currentProject = maDa;
  // Clear other caches that depend on project scope
  if (window._vnecCacheInvalidate) window._vnecCacheInvalidate();
}

export function clearSessionCache() {
  _cache = { myProjects: null, currentProject: null, lastFetch: 0 };
}

// Helper: check if user needs to pick a project before proceeding
// Returns: { needsPick, projects, current, isDataEntry }
export async function checkProjectGate(user) {
  if (!user) return { needsPick: false, projects: [], current: null, isDataEntry: false };
  const isDataEntry = user.role === 'data_entry' || user.role === 'viewer';
  if (!isDataEntry) {
    // Admin/approver: không cần chọn dự án, nhưng có thể đổi trong sidebar
    return { needsPick: false, projects: [], current: null, isDataEntry: false };
  }

  const projects = await getMyProjects();
  const current = await getCurrentProject();

  if (!projects.length) {
    return { needsPick: false, projects: [], current: null, isDataEntry: true, noAccess: true };
  }

  // Nếu có current đã set và current nằm trong danh sách quyền → OK
  if (current && projects.find(p => p.ma_da === current)) {
    return { needsPick: false, projects, current, isDataEntry: true };
  }

  // Nếu chỉ có 1 dự án → auto chọn
  if (projects.length === 1) {
    await setCurrentProject(projects[0].ma_da);
    return { needsPick: false, projects, current: projects[0].ma_da, isDataEntry: true };
  }

  // Nếu có dự án default → auto chọn
  const def = projects.find(p => p.is_default);
  if (def) {
    await setCurrentProject(def.ma_da);
    return { needsPick: false, projects, current: def.ma_da, isDataEntry: true };
  }

  // Phải chọn
  return { needsPick: true, projects, current: null, isDataEntry: true };
}
